import { HttpClient } from '@angular/common/http';
import { Inject, LOCALE_ID, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class I18nMessageService {
  constructor(@Inject(LOCALE_ID) public localeID: string, private http: HttpClient) {}

  i18nMessage = {};
  getI18nJson() {
    return this.http.get('/translate/messages/json').pipe(
      tap((res: any) => {
        this.i18nMessage = res || {};
      })
    );
  }

  getZH(message: string): string {
    return this.i18nMessage[message] ? this.i18nMessage[message].zh : message;
  }
}
